import { render, staticRenderFns } from "./CallerIdVerificationLimit.vue?vue&type=template&id=24cf2318&"
import script from "./CallerIdVerificationLimit.vue?vue&type=script&lang=js&"
export * from "./CallerIdVerificationLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports